module.exports = __webpack_public_path__ + "static/media/icon-not-found.3a3859bf.png";